import { Palette } from 'Palette';

export const graphColorPalette = ['#5881A0', '#A85551', '#8B995F', '#74538C', '#C6844E', '#498E82'];

export function getColorForLabel(index: number): string {
  return graphColorPalette[index % graphColorPalette.length];
}

const toneOrder: (keyof typeof Palette)[] = [
  'default',
  'tone1',
  'tone2',
  'tone3',
  'tone4',
  'tone5',
];

export const determinePreviousTone = (
  tone: keyof typeof Palette,
  step: number = 1,
): keyof typeof Palette => {
  const currentIndex = toneOrder.indexOf(tone);
  if (currentIndex === -1) return 'default';

  const newIndex = (currentIndex - step + toneOrder.length) % toneOrder.length;
  return toneOrder[newIndex];
};

export const determineNextTone = (
  tone: keyof typeof Palette,
  step: number = 1,
): keyof typeof Palette => {
  const currentIndex = toneOrder.indexOf(tone);
  if (currentIndex === -1) return 'default';

  const newIndex = (currentIndex + step) % toneOrder.length;
  return toneOrder[newIndex];
};
